import { getResults, getResultAnswers } from '../../shared/services/apiService';

// ── Load all results (no server-side pagination in current API) ──────────────
export const loadResults = async () => {
  const res = await getResults();
  return res.data.data.results;
};

// ── Load per-result answer breakdown ─────────────────────────────────────────
export const loadResultAnswers = async (resultId) => {
  const res = await getResultAnswers(resultId);
  return res.data.data.answers;
};

// ── Client-side pagination helpers ───────────────────────────────────────────
export const PAGE_SIZE = 20;

export const paginateResults = (allResults, page) => {
  const total      = allResults.length;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  const safePage   = Math.min(Math.max(1, page), totalPages);
  const start      = (safePage - 1) * PAGE_SIZE;
  const pageData   = allResults.slice(start, start + PAGE_SIZE);
  return { pageData, total, totalPages, currentPage: safePage };
};

// ── Status badge helper ───────────────────────────────────────────────────────
export const statusBadgeClass = (status) =>
  ({ submitted: 'badge-green', force_submitted: 'badge-red', timed_out: 'badge-red', in_progress: 'badge-gold' }[status] || 'badge-purple');
